import React, { Component } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import MutationInfo from '../../../common/components/MutationInfo';
import SaveButtonWithTooltip from '../../../common/components/SaveButtonWithTooltip';
import Form from './Form.js';
import {
  emptyOrValidDate,
  datesInOrder,
  report
} from '../../../../common/utils/inputValidator.js';

export default class EventModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      save: {
        enabled: false,
        errors: []
      }
    };
  }

  saveEnabled = (data) => {
    const checks = [
      // TODO title check
      emptyOrValidDate(data.beginDate, 'Begin date'), 
      emptyOrValidDate(data.endDate, 'End date'),
      datesInOrder([data.beginDate, data.endDate]),
    ];

    return report(checks);
  };

  handleUpdate = (data) => {
    this.setState(prevState => {
      const newState = {...prevState};
      newState.save = this.saveEnabled(data);
      return newState;
    });
  }

  handleSave = () => {
    this.props.onSave(this.formInstance.state);
  };
  
  render() {
    const { modal, title } = this.props;

    return (
      <Modal open={modal.opened}>
        <Modal.Header
          content={modal.data.id ? `Edit ${title} (${modal.data.id})` : `Add ${title}`}/>
        <Modal.Content>
          {/* <I18nMenu /> */}
          <Form
            data={modal.data}
            onUpdate={this.handleUpdate}
            ref={instance => { this.formInstance = instance; }}/>
        </Modal.Content>
        <Modal.Actions>
          <MutationInfo
            who={modal.data.createdBy}
            when={modal.data.createdAt}/>
          <Button negative content='Cancel' onClick={this.props.onClose}/>
          <SaveButtonWithTooltip
            enabled={this.state.save.enabled}
            tooltip={this.state.save.errors}
            onSave={this.handleSave}/>
        </Modal.Actions>
      </Modal>
    );
  };
};



// WEBPACK FOOTER //
// ./src/private/admin/components/Event/index.js